import { cartHandler } from "../handlers/cartHandler";
import { blHandler } from "../handlers/blHandler";
import { bfslHandler } from "../handlers/bfslHandler";
import { blseHandler } from "../handlers/blseHandler";
import { SSORedirectArgs, SSOURLConfigs } from "../types/SSO.types";
import { myAccountHandler } from "../handlers/myAccountHandler";
import { plHandler } from "../handlers/plHandler";
import { dcHandler } from "../handlers/dcHandler";
import { cvHandler } from "../handlers/cvHandler";
import { carLoanHandler } from "../handlers/carLoanHandler";
import { emiHandler } from "../handlers/emiHandler";
import { triggerFallBackPopup } from "@repo/global-store/fallback-popup";
import { tfHandler } from "../handlers/tfHandler";
import { nclHandler } from "../handlers/nclHandler";
import { twfHandler } from "../handlers/twfHandler";
import { dlHandler } from "../handlers/dlHandler";
import { lflHandler } from "../handlers/lflHandler";
import { caHandler } from "../handlers/caHandler";
import { solarHandler } from "../handlers/solarHandler";
import { solarFormHandler } from "../handlers/solarFormHandler";

export const ssoHandlerMap = {
  cart: cartHandler,
  bl: blHandler,
  bfsl: bfslHandler,
  blse: blseHandler,
  myaccount: myAccountHandler,
  pl: plHandler,
  dc: dcHandler,
  ncv: cvHandler,
  lcv: cvHandler,
  cvbt: cvHandler,
  ucv: cvHandler,
  zbt: carLoanHandler,
  zlc: carLoanHandler,
  zcuc: carLoanHandler,
  tf: tfHandler,
  twl: twfHandler,
  ncl: nclHandler,
  emi: emiHandler,
  dl: dlHandler,
  lfl: lflHandler,
  ca: caHandler,
  solar: solarHandler,
  slrForm: solarFormHandler,
} as const;

export type HandlerNames = keyof typeof ssoHandlerMap;

const openDefaultRedirect = (data: SSORedirectArgs) => {
  const redirectUrl = data.mapping.newUrl.toString();
  const target = data.target || "_self";
  const openedWindow = window.open(redirectUrl, target);

  // Async SSO flows can lose the original user gesture, so popup blockers may reject
  // a new-tab redirect. Fall back to same-tab navigation so banner clicks still resolve.
  if (!openedWindow && target === "_blank") {
    window.location.assign(redirectUrl);
  }
};

/**
 * callHandler
 */
export const callHandler = (mapping: SSOURLConfigs, data: SSORedirectArgs) => {
  try {
    const handler = mapping.ssoModule
      ? ssoHandlerMap[mapping.ssoModule as HandlerNames]
      : undefined;

    if (handler) {
      handler(data);
      return;
    }

    openDefaultRedirect(data);
  } catch (error) {
    triggerFallBackPopup();
    console.error(error);
    throw error;
  }
};
